
export const STRICTLY_NUMERIC_TYPES = ["number", "currency", "integer", "decimal"];

export const FIELD_TYPES = {
  NUMERIC: ["text", ...STRICTLY_NUMERIC_TYPES],
  DATE: ["date", "datetime", "date_time", "dateandtime", "date_and_time"],
  BOOLEAN: ["boolean"],
  SELECT: ["select", "dropdown"],
  USER: ["user", "owner"],
  TAGS: ["tags", "multi_select"]
};

export const FILTER_CONFIG = {
  SEARCH_TIMEOUT: 150,
  DEFAULT_OPERATOR: "equals"
};

export const isNumericField = (fieldType) => {
  if (!fieldType) return false;
  return FIELD_TYPES.NUMERIC.includes(fieldType.toLowerCase());
};

export const isDateField = (fieldType) => {
  if (!fieldType) return false;
  return FIELD_TYPES.DATE.includes(fieldType.toLowerCase());
};

export const isBooleanField = (fieldType) => {
  if (!fieldType) return false;
  return fieldType.toLowerCase() === "boolean";
};

export const isSelectField = (fieldType) => {
  if (!fieldType) return false;
  return FIELD_TYPES.SELECT.includes(fieldType.toLowerCase());
};

export const isUserField = (fieldType) => {
  if (!fieldType) return false;
  return FIELD_TYPES.USER.includes(fieldType.toLowerCase());
};

export const isTagsField = (fieldType) => {
  if (!fieldType) return false;
  return FIELD_TYPES.TAGS.includes(fieldType.toLowerCase());
};


export const buildFilterFlags = (fieldType, filter = {}) => {
  const flags = {};
  const normalizedType = fieldType?.toLowerCase();

  if (isNumericField(normalizedType)) {
    flags.isTextInput = true;
  }

  if (isDateField(normalizedType)) {
    flags.isTextInput = true;
    flags.isDateInput = true;
  }

  if (isBooleanField(normalizedType)) {
    flags.isBooleanInput = true;
  }

  if (isSelectField(normalizedType)) {
    flags.searchable = true;
    if (filter.multiSelect) {
      flags.isMultiSelectInput = true;
    } else {
      flags.isSelectInput = true;
    }
  }

  if (isUserField(normalizedType)) {
    flags.searchable = true;
    flags.showInitials = true;
    flags.isUserInput = true;
  }

  if (filter.multiSelect || isTagsField(normalizedType)) {
    flags.searchable = true;
    if (!flags.isSelectInput && !flags.isUserInput) {
      flags.isMultiSelectInput = true;
    }
  }

  return flags;
};

export const FILTER_ID_MAPPINGS = {
  deal_owner_id: "deal_owner",
  current_company: "company",
  owner_id: "owner",
  expected_close_date: "close_date"
};


export const mapFilterId = (slug) => {
  return FILTER_ID_MAPPINGS[slug] || slug;
};
